/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum RoutesPage {
  'Search Fitting' = '/app-search-fitting',
  'Add New Size' = '/app-add-fitting-size',
  'Discontinue/Continue Existing Size' = '/app-delete-fitting-size',
  'Update Existing Size' = '/app-update-fitting-size',
  'Pending Request For Approval' = '/app-fitting-approval-page',
  'Change Fitting State' = '/app-fitting-state-management',
  'Pending Requests Fitting State ' = '/app-fitting-state-approval',
  'Assign Role and Rights' = '/app-user-settings-page',
  'Download Fittings' = '/app-download',
  'Upload Fittings' = '/app-upload',
  'Copy Blob Files' = '/app-copy-blob-files',
  
}
